import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Coordinate from '../../geom/Coordinate';
import Polygon from '../../geom/Polygon';
import RectangleLineIntersector from '../../algorithm/RectangleLineIntersector';
import ShortCircuitedGeometryVisitor from '../../geom/util/ShortCircuitedGeometryVisitor';
import SimplePointInAreaLocator from '../../algorithm/locate/SimplePointInAreaLocator';
import LinearComponentExtracter from '../../geom/util/LinearComponentExtracter';
var RectangleIntersects = /*#__PURE__*/function () {
  function RectangleIntersects() {
    _classCallCheck(this, RectangleIntersects);
    RectangleIntersects.constructor_.apply(this, arguments);
  }
  _createClass(RectangleIntersects, [{
    key: "intersects",
    value: function intersects(geom) {
      if (!this._rectEnv.intersects(geom.getEnvelopeInternal())) return false;
      var visitor = new EnvelopeIntersectsVisitor(this._rectEnv);
      visitor.applyTo(geom);
      if (visitor.intersects()) return true;
      var ecpVisitor = new GeometryContainsPointVisitor(this._rectangle);
      ecpVisitor.applyTo(geom);
      if (ecpVisitor.containsPoint()) return true;
      var riVisitor = new RectangleIntersectsSegmentVisitor(this._rectangle);
      riVisitor.applyTo(geom);
      if (riVisitor.intersects()) return true;
      return false;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._rectangle = null;
      this._rectEnv = null;
      var rectangle = arguments[0];
      this._rectangle = rectangle;
      this._rectEnv = rectangle.getEnvelopeInternal();
    }
  }, {
    key: "intersects",
    value: function intersects(rectangle, b) {
      var rp = new RectangleIntersects(rectangle);
      return rp.intersects(b);
    }
  }]);
  return RectangleIntersects;
}();
export { RectangleIntersects as default };
var EnvelopeIntersectsVisitor = /*#__PURE__*/function (_ShortCircuitedGeomet) {
  _inherits(EnvelopeIntersectsVisitor, _ShortCircuitedGeomet);
  function EnvelopeIntersectsVisitor() {
    var _this;
    _classCallCheck(this, EnvelopeIntersectsVisitor);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(EnvelopeIntersectsVisitor).call(this));
    EnvelopeIntersectsVisitor.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(EnvelopeIntersectsVisitor, [{
    key: "isDone",
    value: function isDone() {
      return this._intersects === true;
    }
  }, {
    key: "visit",
    value: function visit(element) {
      var elementEnv = element.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) return null;
      if (this._rectEnv.contains(elementEnv)) {
        this._intersects = true;
        return null;
      }
      if (elementEnv.getMinX() >= this._rectEnv.getMinX() && elementEnv.getMaxX() <= this._rectEnv.getMaxX()) {
        this._intersects = true;
        return null;
      }
      if (elementEnv.getMinY() >= this._rectEnv.getMinY() && elementEnv.getMaxY() <= this._rectEnv.getMaxY()) {
        this._intersects = true;
        return null;
      }
    }
  }, {
    key: "intersects",
    value: function intersects() {
      return this._intersects;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._rectEnv = null;
      this._intersects = false;
      var rectEnv = arguments[0];
      this._rectEnv = rectEnv;
    }
  }]);
  return EnvelopeIntersectsVisitor;
}(ShortCircuitedGeometryVisitor);
var GeometryContainsPointVisitor = /*#__PURE__*/function (_ShortCircuitedGeomet2) {
  _inherits(GeometryContainsPointVisitor, _ShortCircuitedGeomet2);
  function GeometryContainsPointVisitor() {
    var _this2;
    _classCallCheck(this, GeometryContainsPointVisitor);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GeometryContainsPointVisitor).call(this));
    GeometryContainsPointVisitor.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this2)), arguments);
    return _this2;
  }
  _createClass(GeometryContainsPointVisitor, [{
    key: "isDone",
    value: function isDone() {
      return this._containsPoint === true;
    }
  }, {
    key: "visit",
    value: function visit(geom) {
      if (!(geom instanceof Polygon)) return null;
      var elementEnv = geom.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) return null;
      var rectPt = new Coordinate();
      for (var i = 0; i < 4; i++) {
        this._rectSeq.getCoordinate(i, rectPt);
        if (!elementEnv.contains(rectPt)) continue;
        if (SimplePointInAreaLocator.containsPointInPolygon(rectPt, geom)) {
          this._containsPoint = true;
          return null;
        }
      }
    }
  }, {
    key: "containsPoint",
    value: function containsPoint() {
      return this._containsPoint;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._rectSeq = null;
      this._rectEnv = null;
      this._containsPoint = false;
      var rectangle = arguments[0];
      this._rectSeq = rectangle.getExteriorRing().getCoordinateSequence();
      this._rectEnv = rectangle.getEnvelopeInternal();
    }
  }]);
  return GeometryContainsPointVisitor;
}(ShortCircuitedGeometryVisitor);
var RectangleIntersectsSegmentVisitor = /*#__PURE__*/function (_ShortCircuitedGeomet3) {
  _inherits(RectangleIntersectsSegmentVisitor, _ShortCircuitedGeomet3);
  function RectangleIntersectsSegmentVisitor() {
    var _this3;
    _classCallCheck(this, RectangleIntersectsSegmentVisitor);
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(RectangleIntersectsSegmentVisitor).call(this));
    RectangleIntersectsSegmentVisitor.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this3)), arguments);
    return _this3;
  }
  _createClass(RectangleIntersectsSegmentVisitor, [{
    key: "intersects",
    value: function intersects() {
      return this._hasIntersection;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return this._hasIntersection === true;
    }
  }, {
    key: "visit",
    value: function visit(geom) {
      var elementEnv = geom.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) return null;
      var lines = LinearComponentExtracter.getLines(geom);
      this.checkIntersectionWithLineStrings(lines);
    }
  }, {
    key: "checkIntersectionWithLineStrings",
    value: function checkIntersectionWithLineStrings(lines) {
      for (var i = lines.iterator(); i.hasNext();) {
        var testLine = i.next();
        this.checkIntersectionWithSegments(testLine);
        if (this._hasIntersection) return null;
      }
    }
  }, {
    key: "checkIntersectionWithSegments",
    value: function checkIntersectionWithSegments(testLine) {
      var seq1 = testLine.getCoordinateSequence();
      for (var j = 1; j < seq1.size(); j++) {
        seq1.getCoordinate(j - 1, this._p0);
        seq1.getCoordinate(j, this._p1);
        if (this._rectIntersector.intersects(this._p0, this._p1)) {
          this._hasIntersection = true;
          return null;
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._rectEnv = null;
      this._rectIntersector = null;
      this._hasIntersection = false;
      this._p0 = new Coordinate();
      this._p1 = new Coordinate();
      var rectangle = arguments[0];
      this._rectEnv = rectangle.getEnvelopeInternal();
      this._rectIntersector = new RectangleLineIntersector(this._rectEnv);
    }
  }]);
  return RectangleIntersectsSegmentVisitor;
}(ShortCircuitedGeometryVisitor);